
/* LOUBNA STORE — Résumé mobile extensible */

(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const labels = () => {
    const lang = (document.documentElement.lang || '').toLowerCase();

    if (lang.startsWith('ar')) {
      return {
        title: 'نبذة سريعة',
        more: 'عرض التفاصيل كاملة',
        less: 'إخفاء التفاصيل'
      };
    }

    if (lang.startsWith('fr')) {
      return {
        title: 'En bref',
        more: 'Voir tous les détails',
        less: 'Masquer les détails'
      };
    }

    return {
      title: 'Quick overview',
      more: 'View full details',
      less: 'Hide details'
    };
  };

  const excerpt = (text, limit = 38) => {
    const words = String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    if (!words.length) return '';

    const shortened = words.slice(0, limit).join(' ');

    return words.length > limit
      ? `${shortened}…`
      : shortened;
  };

  const init = () => {
    if (!mobileQuery.matches) return;

    const main = document.querySelector(
      'main[data-template="product"]'
    );

    const info = main?.querySelector(
      '.product__info-container'
    );

    if (!info) return;

    if (
      info.querySelector('.product__mobile-quick-summary')
    ) return;

    const description = info.querySelector(
      '.product__description'
    );

    const productForm = info.querySelector(
      'product-form'
    );

    if (!description || !productForm) return;

    const isAfterForm = Boolean(
      productForm.compareDocumentPosition(description) &
      Node.DOCUMENT_POSITION_FOLLOWING
    );

    if (!isAfterForm) return;

    const text = excerpt(description.textContent, 38);

    if (!text) return;

    const copy = labels();

    const summary = document.createElement('div');
    summary.className = 'product__mobile-quick-summary';
    summary.setAttribute('aria-label', copy.title);

    const title = document.createElement('p');
    title.className = 'product__mobile-quick-summary-title';
    title.textContent = copy.title;

    const body = document.createElement('p');
    body.className = 'product__mobile-quick-summary-text';
    body.textContent = text;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'product__mobile-quick-summary-link';
    button.textContent = copy.more;
    button.setAttribute('aria-expanded', 'false');

    if (!description.id) {
      description.id = 'ProductDescriptionMobile';
    }

    button.setAttribute(
      'aria-controls',
      description.id
    );

    button.addEventListener('click', () => {
      const isExpanded = description.classList.toggle(
        'is-mobile-expanded'
      );

      button.setAttribute(
        'aria-expanded',
        String(isExpanded)
      );

      button.textContent = isExpanded
        ? copy.less
        : copy.more;

      if (isExpanded) {
        description.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    });

    summary.append(title, body, button);

    productForm.insertAdjacentElement(
      'beforebegin',
      summary
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

  mobileQuery.addEventListener?.('change', (event) => {
    if (event.matches) init();
  });

  document.addEventListener(
    'shopify:section:load',
    init
  );
})();
